import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  globalLoading: false,
};

const LoaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.globalLoading = true;
    },
    hideLoader: (state) => {
      state.globalLoading = false;
    },
  },
});

export const { showLoader, hideLoader } = LoaderSlice.actions;
export default LoaderSlice.reducer;
